import * as actionTypes from './sendableStatesActionTypes';

const initialState={
   SendableStates:[]
}

export default function sendableStatesReducer(state = initialState, action){

    switch(action.type){
        case (actionTypes.SET_SENDABLE_STATES):
            if(action.sendableStates !== state.SendableStates){
                return Object.assign({}, state,{SendableStates: action.sendableStates});
            }
            return state;   
    
        default:
            return state;
    }
}


